import { AgColDefsI, AgGridI } from "../../shared/common-components/ag-grid/ag-grid.model"
import { ButtonCellrendererComponent } from "../../shared/common-components/ag-grid/button-cellrenderer/button-cellrenderer.component"
import { CustomHeaderComponent } from "../../shared/common-components/ag-grid/custom-header/custom-header.component"
import { NumericEditorComponent } from "../../shared/common-components/ag-grid/numeric-editor/numeric-editor.component"
import { TextRendererComponent } from "../../shared/common-components/ag-grid/text-renderer/text-renderer.component"
import { TextSvgCellrenderComponent } from "../../shared/common-components/ag-grid/text-svg-cellrender/text-svg-cellrender.component"
import { ContactColWidth, DateColWidth } from "../../shared/enum/common-enum"


const FullNameColumn: AgColDefsI =
{
    headerName: "FullName",
    headerComponent: CustomHeaderComponent,
    sortable: true,
    field: "fullName",
    headerClass: "custom-column-group-cell",
    cellClass: "custom-column-group-cell",
    flex: 3,
    minWidth: 100,
    cellRenderer: TextRendererComponent,
    cellRendererParams: { isCursor: true },
    lockPinned: true,
    lockPosition: 'left',
    suppressMovable: false,
    editable: false
}
const UserNameColumn: AgColDefsI =
{
    headerName: "UserName",
    headerComponent: CustomHeaderComponent,
    sortable: true,
    field: "userName",
    headerClass: "custom-column-group-cell",
    cellClass: "custom-column-group-cell",
    flex: 3,
    minWidth: 100,
    cellRenderer: TextRendererComponent,
    cellRendererParams: { isCursor: true },
    lockPinned: true,
    lockPosition: 'left',
    suppressMovable: false,
    editable: false
}
const PasswordColumn: AgColDefsI =
{
    headerName: "Password",
    headerComponent: CustomHeaderComponent,
    sortable: true,
    field: "password",
    headerClass: "custom-column-group-cell",
    cellClass: "custom-column-group-cell",
    flex: 3,
    minWidth: 100,
    cellRenderer: TextRendererComponent,
    cellRendererParams: { isCursor: true },
    lockPinned: true,
    lockPosition: 'left',
    suppressMovable: false,
    editable: false
}
const ContactNoColumn: AgColDefsI =
{
    headerName: "ContactNo",
    headerComponent: CustomHeaderComponent,
    sortable: true,
    field: "contactNo",
    headerClass: "custom-column-group-cell",
    cellClass: "custom-column-group-cell",
    flex: 3,
    minWidth: 100,
    cellRenderer: TextRendererComponent,
    cellRendererParams: { isCursor: true },
    lockPinned: true,
    lockPosition: 'left',
    suppressMovable: false,
    editable: false
}
const EmailColumn: AgColDefsI =
{
    headerName: "Email",
    headerComponent: CustomHeaderComponent,
    sortable: true,
    field: "email",
    headerClass: "custom-column-group-cell",
    cellClass: "custom-column-group-cell",
    flex: 3,
    minWidth: 100,
    cellRenderer: TextRendererComponent,
    cellRendererParams: { isCursor: true },
    lockPinned: true,
    lockPosition: 'left',
    suppressMovable: false,
    editable: false
}
const registerduseridColumn: AgColDefsI =
{
    headerName: "Registerd User Id",
    headerComponent: CustomHeaderComponent,
    sortable: true,
    field: "registeredUserId",
    headerClass: "custom-column-group-cell",
    cellClass: "custom-column-group-cell",
    flex: 3,
    minWidth: 100,
    cellRenderer: TextRendererComponent,
    cellRendererParams: { isCursor: true },
    lockPinned: true,
    lockPosition: 'left',
    suppressMovable: false,
    editable: false
}
const PhoneNumberColumn: AgColDefsI = {
    headerName: "Phone Number",
    field: 'phoneNumberId',
    headerComponent: CustomHeaderComponent,
    minWidth: 150,
    sortable: true,
    editable: true,
    headerClass: 'custom-column-group-cell px-2',
    cellClass: 'custom-column-group-cell ps-3 pe-2',
    cellRendererParams: { isCursor: true },
    cellRenderer: TextRendererComponent,
    cellEditor: NumericEditorComponent,
    flex: 1
};
const WabaId: AgColDefsI = {
    headerName: "Waba Id",
    field: 'wabaId',
    headerComponent: CustomHeaderComponent,
    minWidth: ContactColWidth.minWidth,
    maxWidth: ContactColWidth.maxWidth,
    sortable: true,
    editable: false,
    headerClass: "custom-column-group-cell",
    cellClass: "custom-column-group-cell",
    cellRendererParams: { isCursor: false },
    cellRenderer: TextRendererComponent
};
const BusinessId: AgColDefsI = {
    headerName: "Business Id",
    field: 'businessId',
    headerComponent: CustomHeaderComponent,
    minWidth: ContactColWidth.minWidth,
    maxWidth: ContactColWidth.maxWidth,
    sortable: true,
    editable: false,
    headerClass: "custom-column-group-cell",
    cellClass: "custom-column-group-cell",
    cellRendererParams: { isCursor: false },
    cellRenderer: TextRendererComponent
};
const AccessToken: AgColDefsI = {
    headerName: "Access Token",
    headerComponent: CustomHeaderComponent,
    field: "accessToken",
    sortable: true,
    headerClass: "custom-column-group-cell",
    cellClass: "custom-column-group-cell",
    flex: 3,
    minWidth: 100,
    cellRenderer: TextRendererComponent,
    cellRendererParams: { isCursor: true },
    lockPinned: true,
    lockPosition: 'left',
    suppressMovable: false,
    editable: false
}

const RegistrationDate: AgColDefsI = {
    headerName: "Registration Dt",
    field: 'registrationDate',
    minWidth: DateColWidth.minWidth,
    maxWidth: DateColWidth.maxWidth,
    headerComponent: CustomHeaderComponent,
    sortable: true,
    editable: false,
    headerClass: "custom-column-group-cell",
    cellClass: "custom-column-group-cell ps-2 d-flex align-item-center",
    cellRenderer: TextRendererComponent,
};

const RenewalDateColumn: AgColDefsI = {
    headerName: "Renewal Date",
    field: 'crmRenewalDate',
    minWidth: DateColWidth.minWidth,
    maxWidth: DateColWidth.maxWidth,
    headerComponent: CustomHeaderComponent,
    sortable: true,
    editable: false,
    headerClass: "custom-column-group-cell",
    cellClass: "custom-column-group-cell ps-2 d-flex align-item-center",
    cellRenderer: TextSvgCellrenderComponent,
};

  const ExtendSubscription: AgColDefsI = {
    headerName: "", 
    field: 'extendSubscription', 
    maxWidth:250,
    minWidth:180,
    sortable: false,
    editable:false,
    headerClass:'',
    lockPinned:true, 
    pinned: 'right',
    lockPosition:'right',
    cellRenderer: ButtonCellrendererComponent,
    cellRendererParams: {
    IsextendSubscription: true,
  },
  cellClass: "ps-0 pe-2 d-flex align-item-center justify-content-center",
  };
  
export const MessagifyUser: AgColDefsI[] = [
    FullNameColumn,
    UserNameColumn,
    PasswordColumn,
    ContactNoColumn,
    EmailColumn,
    registerduseridColumn,
    PhoneNumberColumn,
    WabaId,
    BusinessId,
    AccessToken,
    RegistrationDate,
    RenewalDateColumn,
    ExtendSubscription
]

export const AgGridDataModelMessagifyUser: AgGridI = {
    colDefs: MessagifyUser,
    rowSelection: "multiple",
    rowHeight: 40,
    showPagination: true,
}